<template>
  <component
    :is="internal ? 'RouterLink' : 'a'"
    :href="internal ? undefined : content.link"
    :to="to"
    :target="internal ? undefined : '_blank'"
    class="cursor-pointer"
  >
    <slot />
    <span v-if="content.label">{{ content.label }}</span>
  </component>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'SiteLink',
  props: {
    content: {
      type: Object as PropType<Link>,
      required: true,
    },
  },
  computed: {
    internal() {
      return (
        this.content.link.startsWith('/') ||
        this.content.link.startsWith('#') ||
        this.content.link.startsWith(this.origin)
      )
    },
    origin() {
      return window.location.origin
    },
    to() {
      if (this.internal) {
        return this.content.link.replace(this.origin, '')
      }

      return undefined
    },
  },
}
</script>
